import { BackLink, LinkProps } from '../../ui';
import React from 'react';
import { Link as RouterLink, LinkProps as RouterLinkProps } from 'react-router';

export interface RouterBackLinkProps {
  to: string;
  underline?: LinkProps['underline'];
}

const RouterBackLink: React.FC<RouterBackLinkProps> = props => {
  const { to, children, underline } = props;

  const renderLink = React.useMemo(
    () =>
      React.forwardRef<
        HTMLAnchorElement,
        Omit<RouterLinkProps, 'innerRef' | 'to'>
      >((itemProps, ref) => (
        <RouterLink
          to={to}
          {...itemProps}
          data-fd="back_link"
          ref={ref as any}
        />
      )),
    [to]
  );

  return (
    <BackLink component={renderLink as any} underline={underline}>
      {children}
    </BackLink>
  );
};

RouterBackLink.defaultProps = {
  //   underline: 'always'
};

export default RouterBackLink;
